import scrollFrame from "../../setup/js/_scrollFrame.2";
import scrollWatch from "../../setup/js/_scrollWatch.2";
$(document).on("metaslug_sinhnhat1tuoi_float_top rendered", {}, function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);

    $("#floatnavtop li a").on("click", function () {
        $("#navBurger").removeClass("is-active");
        $(".floattop__nav").removeClass("active");
    });
    $("#navBurger").on("click", function () {
        $(".floattop__nav").toggleClass("active");
        $(this).toggleClass("active");
    });
    // scrollFrame.init();
    // scrollWatch.init({
    //     options: {
    //         onElementInView: function(e){
    //             var $this = $(e.el).parents("[data-block-id]");
    //             var dataBlockId = $this.attr("data-block-id");
    //             //console.log(dataBlockId);
    //             $(`.floatnav--nav[data-fts-selector='data-block-id="${dataBlockId}"']`);
    //             $(`[data-fts-selector='[data-block-id="${dataBlockId}"]']`).addClass("act");
    //         },
    //         onElementOutOfView: function(e){
    //             var $this = $(e.el).parents("[data-block-id]");
    //             var dataBlockId = $this.attr("data-block-id");
    //             //console.log(dataBlockId);
    //             $(`[data-fts-selector='[data-block-id="${dataBlockId}"]']`).removeClass("act");

    //         }
    //     }
    // });
});